import { cn } from "../../utils/lib";
import { ErrorMsg } from "../common";
import { Label } from "./Label";

interface TextAreaProps {
    name?: string;
    label?: string;
    isError?: boolean;
    errorMessage?: string;
    helperText?: string;
    className?: string;
    placeholder?: string;
    value: string;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    disabled?: boolean;
    rows?: number;
    required?: boolean;
}

const TextArea = ({
    name = "text area",
    label,
    helperText,
    className = "",
    placeholder = "",
    value,
    onChange,
    disabled = false,
    rows = 4,
    errorMessage,
    isError,
    required = false,
}: TextAreaProps) => {
    return (
        <div className={cn("flex w-full flex-col text-sm 2xl:text-sm", className)}>
            {label && (
                <Label
                    htmlFor={name}
                    text={label}
                    required={required}
                    className="mb-1.5 2xl:mb-2"
                />
            )}

            <textarea
                className={cn(
                    "min-h-[80px] w-full rounded-lg border bg-white px-3 py-2 placeholder-gray-400 outline-primary transition-all duration-200 placeholder:text-gray-300 focus:border-primary focus:outline-primary",
                    isError && "border-red-500",
                    disabled && "cursor-not-allowed bg-gray-50 text-gray-500",
                    className,
                )}
                name={name}
                id={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
            />

            {helperText && !isError && (
                <p className="mt-1 text-sm text-gray-500">{helperText}</p>
            )}

            {isError && errorMessage && <ErrorMsg text={errorMessage} />}
        </div>
    );
};

export { TextArea };

